module.exports = __webpack_public_path__ + "img/swiper_05.cde6a404.jpg";